import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { FvmsApiBaseService } from "./fvms.api.base.service";

@Injectable({providedIn: 'root'})
export class FvmsApiDtgTeamService extends FvmsApiBaseService {
    constructor(
        public http:HttpClient
    ) {
        super(http);
    }

    getListTeam(searchInfo:any,pagingInfo:any):Observable<any>{
        let url = this.getApiBaseUrl() + "/dtg/team";
        url += "/manage/team/list";

        let header = new HttpHeaders({
            "Content-Type":"application/json"
        });

        // searchInfo = {
        //     "companyId":1
        //     ,"dtgTeamId":1
        //     ,"searchValue":"검색어"
        // };
        // pagingInfo = {
        //     "curPage":1
        //     ,"pageSize":100
        // };
        let tmpPostObject = {
            "searchInfo":searchInfo
            ,"pagingInfo":pagingInfo
        };

        //객체가 연결되어 있어서 주입된 객체에 값을 변경하면 ui의 값도 같이 바뀐다
        //때문에 객체를 복사해서 사용
        let tmpData = JSON.parse(JSON.stringify(tmpPostObject));

        let bodyData = JSON.stringify(tmpData);

        return this.http.post<any>(url,bodyData,{ headers : header });
    }

    getOneTeam(searchInfo:any):Observable<any>{
        let url = this.getApiBaseUrl() + "/dtg/team";
        url += "/manage/team/detail";

        let header = new HttpHeaders({
            "Content-Type":"application/json"
        });

        // searchInfo = {
        //     "companyId":1
        //     ,"dtgTeamId":1
        // };
        let tmpPostObject = {
            "searchInfo":searchInfo
            ,"pagingInfo":null
        };

        //객체가 연결되어 있어서 주입된 객체에 값을 변경하면 ui의 값도 같이 바뀐다
        //때문에 객체를 복사해서 사용
        let tmpData = JSON.parse(JSON.stringify(tmpPostObject));

        let bodyData = JSON.stringify(tmpData);

        return this.http.post<any>(url,bodyData,{ headers : header });
    }

    upsertTeam(searchInfo:any):Observable<any>{
        let url = this.getApiBaseUrl() + "/dtg/team";
        url += "/manage/team/upsert";

        let header = new HttpHeaders({
            "Content-Type":"application/json"
        });

        // searchInfo = {
        //     "companyId":1
        //     ,"dtgTeamId":1
        // };
        let tmpPostObject = {
            "searchInfo":searchInfo
            ,"pagingInfo":null
        };

        //객체가 연결되어 있어서 주입된 객체에 값을 변경하면 ui의 값도 같이 바뀐다
        //때문에 객체를 복사해서 사용
        let tmpData = JSON.parse(JSON.stringify(tmpPostObject));

        let bodyData = JSON.stringify(tmpData);

        return this.http.post<any>(url,bodyData,{ headers : header });
    }
}